import { useVehicleStore } from '@/modules/vehicles/store/useVehicleStore';
import { useLoadCarrierStore } from '@/modules/loadCarriers/store/useLoadCarrierStore';
import { useAppMetaStore } from '@/modules/floorplanV2/store/project/projectState';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';

import { useAppStore } from '../store/useAppStore';
import { AppServiceImpl } from './AppServiceImpl';
import { IAppService } from './IAppService';
import { AppServiceLogDecorator } from './AppServiceLogDecorator';

export class AppServiceFactory {
  private static instance: AppServiceFactory | null = null;
  private appStore: typeof useAppStore;
  private appMetaStore: typeof useAppMetaStore;
  private vehicleStore: typeof useVehicleStore;
  private loadCarrierStore: typeof useLoadCarrierStore;
  private floorplanDesignStore: typeof useFloorplanDesignStore;

  public static initialize(
    appStore: typeof useAppStore,
    appMetaStore: typeof useAppMetaStore,
    vehicleStore: typeof useVehicleStore,
    loadCarrierStore: typeof useLoadCarrierStore,
    floorplanDesignStore: typeof useFloorplanDesignStore,
  ) {
    AppServiceFactory.instance = new AppServiceFactory(
      appStore,
      appMetaStore,
      vehicleStore,
      loadCarrierStore,
      floorplanDesignStore,
    );
  }

  public static getInstance() {
    if (AppServiceFactory.instance === null) {
      throw new Error(
        'AppServiceFactory not yet initialized. Call AppServiceFactory.initialize() first.',
      );
    }
    return AppServiceFactory.instance;
  }

  private constructor(
    appStore: typeof useAppStore,
    appMetaStore: typeof useAppMetaStore,
    vehicleStore: typeof useVehicleStore,
    loadCarrierStore: typeof useLoadCarrierStore,
    floorplanDesignStore: typeof useFloorplanDesignStore,
  ) {
    this.appStore = appStore;
    this.appMetaStore = appMetaStore;
    this.vehicleStore = vehicleStore;
    this.loadCarrierStore = loadCarrierStore;
    this.floorplanDesignStore = floorplanDesignStore;
  }

  public createAppService(): IAppService {
    let result: IAppService = this.makeAppService();

    result = new AppServiceLogDecorator(result);

    return result;
  }

  private makeAppService(): IAppService {
    return new AppServiceImpl(
      this.appStore,
      this.appMetaStore,
      this.vehicleStore,
      this.loadCarrierStore,
      this.floorplanDesignStore,
    );
  }
}
